import { type APPLICANT_ATTRIBUTION_BOTH_TYPE, INFORMATION_SOURCE } from 'cpool-constants';

import type { SchemaCreditRequestForm } from '../../schemas/creditRequestForm.schema';
import type {
    DISPOSITIONSKREDIT_TYPE,
    GESCHAEFTSKREDIT_TYPE,
    IMMOBILIENDARLEHEN_TYPE,
    KONTOKORRENTKREDIT_TYPE,
    KREDITKARTE_TYPE,
    LEASING_TYPE,
    LoanType,
    RATENKREDIT_TYPE,
    SONSTIGE_VERBINDLICHKEITEN_TYPE,
} from '../../types';
import {
    DISPOSITIONSKREDIT,
    GESCHAEFTSKREDIT,
    IMMOBILIENDARLEHEN,
    KONTOKORRENTKREDIT,
    KREDITKARTE,
    LEASING,
    RATENKREDIT,
    SONSTIGE_VERBINDLICHKEITEN,
} from '../../types';

export const getNewCredit = <T extends LoanType>({
    creditType,
    selectedApplicant,
}: {
    creditType: T;
    selectedApplicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
}): SchemaCreditRequestForm[T][number] => {
    const base = {
        createdAt: null,
        gehoertZuAntragsteller: selectedApplicant,
        glaeubiger: null,
        hide: false,
        id: '',
        source: INFORMATION_SOURCE.MANUALLY,
        zinssatz: null,
    };

    switch (creditType) {
        case GESCHAEFTSKREDIT:
        case RATENKREDIT:
        case SONSTIGE_VERBINDLICHKEITEN:
        case IMMOBILIENDARLEHEN:
            return {
                ...base,
                abloesen: false,
                bic: null,
                datumErsteZahlung: null,
                datumLetzteRate: null,
                iban: null,
                kreditinstitut: null,
                kreditLaufzeit: null,
                rateMonatlich: null,
                restschuld: null,
                schlussrate: null,
                urspruenglicherKreditbetrag: null,
            } satisfies
                | SchemaCreditRequestForm[GESCHAEFTSKREDIT_TYPE][number]
                | SchemaCreditRequestForm[RATENKREDIT_TYPE][number]
                | SchemaCreditRequestForm[SONSTIGE_VERBINDLICHKEITEN_TYPE][number]
                | SchemaCreditRequestForm[IMMOBILIENDARLEHEN_TYPE][number];
        case DISPOSITIONSKREDIT:
            return {
                ...base,
                abloesen: false,
                beanspruchterBetrag: null,
                bic: null,
                iban: null,
                kreditinstitut: null,
                verfuegungsrahmen: null,
            } satisfies SchemaCreditRequestForm[DISPOSITIONSKREDIT_TYPE][number];
        case KREDITKARTE:
            return {
                ...base,
                abloesen: false,
                beanspruchterBetrag: null,
                bic: null,
                iban: null,
                kreditinstitut: null,
                rateMonatlich: null,
                verfuegungsrahmen: null,
            } satisfies SchemaCreditRequestForm[KREDITKARTE_TYPE][number];
        case LEASING:
            return {
                ...base,
                datumLetzteRate: null,
                rateMonatlich: null,
                schlussrate: null,
            } satisfies SchemaCreditRequestForm[LEASING_TYPE][number];
        case KONTOKORRENTKREDIT:
            return {
                ...base,
                beanspruchterBetrag: null,
                verfuegungsrahmen: null,
            } satisfies SchemaCreditRequestForm[KONTOKORRENTKREDIT_TYPE][number];
        default:
            throw new Error(`Invalid credit type: ${creditType}`);
    }
};
